// Preselect tokens. newFlow comes from useEsignFlow: true | false | null (unknown).
// - New eSign flow (true): the customer fills KYC first, then Pay Now (with Aadhaar eSign) shows.
// - Old flow (false) and unknown (null): the original Fill KYC rule and an always-enabled Pay Now.
//   Pay Now still asks the server about eSign when unknown, so the new flow is enforced if the lookup failed.

const PAYABLE_STATUSES = ["Payment Pending", "Partial Payment Done", "Preselected"];

// Same rule the preselect Pay Now button has always used.
export function preselectPayNowShown(token) {
  const t = token?.eventTokenId?.tokenId;
  if (!t?.isPreselect || t?.isPriorityPass) return false;
  const status = token?.allotmentPaymentId?.status || "";
  if (!PAYABLE_STATUSES.some((s) => status.includes(s))) return false;
  const paid = Number(token?.paidAmount) || 0;
  return paid === 0 || paid < Number(token?.amount);
}

// Original rule: alloted / refund rejected preselect tokens with KYC not done.
// New flow also shows it whenever preselect Pay Now shows.
export function preselectFillKycShown(token, newFlow) {
  if (!token?.eventTokenId?.tokenId?.isPreselect || token?.kycFormFilled) return false;
  const oldRule = token?.status === "alloted" || token?.status === "refund rejected";
  if (newFlow !== true) return oldRule;
  return oldRule || preselectPayNowShown(token);
}

// New flow only: Pay Now is hidden (the KYC_FIRST_TEXT line shows instead) until KYC is done.
export const kycFirstPayNowHidden = (kycFormFilled, newFlow) => newFlow === true && kycFormFilled !== true;
export const preselectPayNowLocked = (token, newFlow) => kycFirstPayNowHidden(token?.kycFormFilled, newFlow);

// Pay Now goes through requireEsign unless the booking is known to be in the old flow.
export const payNowNeedsEsign = (newFlow) => newFlow !== false;

export const KYC_FIRST_TEXT = "Please fill KYC first to pay";

// KYC button: "Complete KYC" in the new eSign flow only; the old flow keeps "Fill KYC".
export const kycButtonLabel = (newFlow) => (newFlow === true ? "Complete KYC" : "Fill KYC");

// New flow only: virtual account details stay hidden until KYC is done.
export const vaDetailsHidden = (kycFormFilled, newFlow) => newFlow === true && !kycFormFilled;
export const VA_AFTER_KYC_TEXT = "Virtual account details will be shown after you complete KYC.";
